export default "__VITE_ASSET__6e6feeff__"